 
 <form nz-form *ngIf="mainformGroup && fieldNew && controlExists" [nzLayout]="'vertical'" [formGroup]="mainformGroup" >
    <nz-form-item [ngStyle]="field.noFormItemMarginBottom?{'margin-bottom':'0'}:{}">
        <nz-form-label *ngIf="!field.noLabel" [nzFor]="fieldNew" [nzRequired]="field.required">{{field.label|translateTA}}</nz-form-label>
        <nz-form-control  [nzValidatingTip]="field.tooltip" nzHasFeedback>
            <nz-input-group [nzSuffix]="inputClearTpl" [nzPrefix]="formulaTpl" nzSearch [nzAddOnAfter]="field.action!=null?suffixIconButton:''">
                <textarea #inputValue nz-input [formControlName]="fieldNew" [placeholder]="field.placeholder|translateTA" [nzSize]="field.size == null? 'default': field.size"
                [nzAutosize]="{ minRows: field.minRows==null?2: field.minRows, maxRows: field.maxRows==null?6: field.maxRows }"
                [disabled]="field.isDisabled"></textarea>
            </nz-input-group>
        </nz-form-control>
    </nz-form-item>
    <ng-template #inputClearTpl>
        @if (mainformGroup.get(fieldNew)?.value) {
            <nz-icon class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle" (click)="mainformGroup.get(fieldNew).setValue(null)" />
        }
    </ng-template>
    <ng-template #formulaTpl>
        @if (field.showFormula) {
            <nz-icon nzType="thunderbolt" (click)="openFormula()"/>
        }
    </ng-template>
        <ng-template #suffixIconButton>
        @if (field.action){
            <div class="action-button-container">
                <button nz-button nzType="primary" nzSearch (click)="openComponentAction($event, field.action)" >
                    <nz-icon [nzType]="field.action.icon" />
                </button>
            </div>
        }
      
    </ng-template>
</form>